







































































































































































import {Component} from "vue-property-decorator";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {BillLadingFeeType} from "@/enums/type/billladingfeetype";
import cloneDeep from "lodash/cloneDeep";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import UploadExcel, {ExcelData} from "@/shared/components/UploadExcel/index.vue";
import {MAPPING_UPDATE_COST_BILL_LADING_EXCEL} from "@/shared/constant";
import InputCurrency from "@/shared/components/InputCurrency/index.vue";
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import {EmployeeType, ExpensePaymentType, PickingListCostType} from "@/enums/type";
import {scanCostUpdateBillLading, updateCostBillLading} from "@/modules/pickinglistcost/services";

const form = {
    updateCostBillLadings: [] as any,
    employeeRowGuid: undefined,
    paymentType: undefined,
    bankAccount: "",
    note: undefined
};

const formTemp = {
    ladingCode: "",
    feeType: BillLadingFeeType.FeePostOfficeDelivery,
    fee: undefined,
    note: undefined
}

const formNotAllocation = {
    employeeRowGuid: undefined,
    paymentType: undefined,
    bankAccount: "",
    cost:[
      // {
      //   id: undefined,
      //   note: "",
      //   reason: "",
      //   totalMoney: undefined,
      // }
    ] as any[],
    type: PickingListCostType.NoLading
};
const tempForm = {
  note: "",
  reason: "",
  totalMoney: undefined,
};

@Component({
    name: "UpdateCost",
    components: {EmployeeSelector, AInputBarCode, InputCurrency, UploadExcel, EnumSelector}
})
export default class extends mixins(CommonMixin) {
    formTemp = {...formTemp};
    form = cloneDeep(form);
    formNotAllocation = cloneDeep(formNotAllocation)
    tempForm = cloneDeep(tempForm)
    ExpensePaymentType = ExpensePaymentType;
    billLadingFeeType = BillLadingFeeType;
    EmployeeType = EmployeeType;
    columns = [
        {
            title: "STT",
            dataIndex: "stt",
            key: "stt",
            align: 'center',
            width: 60
        },
        {
            title: "Mã vận đơn",
            dataIndex: "billLadingCode",
            key: "billLadingCode",
            align: 'center',
            scopedSlots: {customRender: "billLadingCode"},
        },
        {
            title: "Tiền phí",
            dataIndex: "fee",
            key: "fee",
            scopedSlots: {customRender: "fee"},
            align: 'center',
        },
        {
            title: "Loại phí",
            dataIndex: "feeType",
            key: "feeType",
            scopedSlots: {customRender: "feeType"},
            align: 'center',
        },
        {
          title: "Ghi chú",
          dataIndex: "note",
          key: "note",
          scopedSlots: {customRender: "note"},
          align: 'center',
        },
        {
            title: "Xóa",
            dataIndex: "billLadingCode",
            key: "rowGuid",
            scopedSlots: {customRender: "action"},
            align: 'center',
            width: 100
        },
    ];
  columnsNotAllocation = [
    {
      title: "STT",
      dataIndex: "stt",
      key: "stt",
      align: 'center',
      width: 60,
      scopedSlots: {customRender: "stt"}
    },
    { title: "Tiền phí",scopedSlots: {customRender: "totalMoney"}, align: 'center', dataIndex: "totalMoney", key: "totalMoney", width: 300 },
    { title: "Lý do chi", align: 'center', dataIndex: "reason", key: "reason" },
    { title: "Ghi chú", align: 'center', dataIndex: "note", key: "note" },
    { title: "Xóa", align: 'center',scopedSlots: {customRender: "actions"}, dataIndex: "actions", key: "actions", width: 100 },
  ];
    exceptFeeType = [
        BillLadingFeeType.FeeReceiver,
        BillLadingFeeType.FeeDelivery
    ];

    created() {
        if (this.isAdmin) {
            this.exceptFeeType = [];
        }
    }

    onEnterLadingCode(val) {
        (this.$refs.feeFormTemp as any).focus();
    }

    onEnterFreeFormTemp(val) {
      (this.$refs.noteFormTemp as any).focus();
    }
    addToTable() {
      const { totalMoney, reason, note } = this.tempForm;
      if (!totalMoney && !reason && !note) return;
      this.formNotAllocation.cost.push({
        id: new Date().getTime(),
        totalMoney,
        reason,
        note,
      });
      this.tempForm.note = "";
      this.tempForm.reason = "";
      this.tempForm.totalMoney = undefined;

      // Focus lại ô đầu tiên (input tiền)
      this.$nextTick(() => {
        const comp = this.$refs.feeFormTemp as Vue;
        const el = comp.$el.querySelector("input") as HTMLInputElement | null;

        if (el) el.focus();
      });
    }

    removeRow(id) {
      this.formNotAllocation.cost = this.formNotAllocation.cost.filter((item) => item.id !== id);
    }

    async saveBillLadingCost() {
        try {
            if (!this.isValidFormTemp()) return;
            await scanCostUpdateBillLading(this.formTemp.ladingCode, this.formTemp.feeType);
            this.form.updateCostBillLadings.push({
                stt: this.form.updateCostBillLadings.length + 1,
                billLadingCode: this.formTemp.ladingCode,
                fee: this.formTemp.fee,
                feeType: this.formTemp.feeType,
                note: this.formTemp.note
            } as any);
            (this.$refs.feeTypeFormTemp as any).$el.focus();
            this.formTemp = { ...formTemp, feeType: this.formTemp.feeType };
        } catch (e) {
            this.$message.error(`${e.response?.data?.message || `Thất bại`}`)
        }
    }

    deleteLading(billLading: any) {
        const index = this.form.updateCostBillLadings.findIndex((lading: any) => billLading.ladingCode === lading.ladingCode);
        this.form.updateCostBillLadings.splice(index, 1);
    }

    async onSave() {
        if (!this.isValidForm()) return;
        await updateCostBillLading(this.form).then(
            (value) => {
                this.$message.success("Cập nhập chi phí thành công");
                this.form = cloneDeep(form);
            })
            .catch((e) => {
                this.$message.error(e?.response?.data?.message || 'Đã xảy ra lỗi');
            })
    }

    isValidForm() {
        if (!this.form.employeeRowGuid) {
            this.$message.error("Chọn nhân viên");
            return false;
        }
        if (!this.form.paymentType) {
            this.$message.error("Chọn hình thức chi");
            return false;
        }
        if (!this.form.updateCostBillLadings || !this.form.updateCostBillLadings.length) {
            this.$message.error("Quét vận đơn để cập nhập");
            return false;
        }
        return true;
    }

    isValidFormTemp() {
        if (!this.formTemp.ladingCode) {
            this.$message.error("Nhập mã vận đơn");
            return false;
        }
        if (!this.formTemp.fee) {
            this.$message.error("Nhập chi phí");
            return false;
        }
        if (!this.formTemp.feeType) {
            this.$message.error("Chọn loại chi phí");
            return false;
        }
        return true;
    }

    onSuccessUpload(excelData: ExcelData) {
        if (!this.isValidFileExcel(excelData.header)) return;
        this.form.updateCostBillLadings = this.mapToJson(excelData.header, excelData.results);
    }

    isValidFileExcel(header) {
        if (!header || !Array.isArray(header) || header.length !== Object.keys(MAPPING_UPDATE_COST_BILL_LADING_EXCEL).length) {
            this.$message.error("File excel bị lỗi");
            return false;
        }
        for (let i = 0; i < header.length; i++) {
            if (!Object.keys(MAPPING_UPDATE_COST_BILL_LADING_EXCEL).includes(header[i])) {
                this.$message.error("File excel bị lỗi");
                return false;
            }
        }
        return true;
    }

    mapToJson(header: Array<string>, results: Array<any>) {
        const mapResults: any = [];
        results.forEach((item: any, index: number) => {
            const obj = {} as any;
            header.forEach((key: string) => {
                const trueKey = MAPPING_UPDATE_COST_BILL_LADING_EXCEL[key];
                if (trueKey) {
                    obj[trueKey] = item[key];
                }
            });
            mapResults.push({
                ...obj,
                stt: index + 1,
            })
        })
        return mapResults;
    }

    isValidFormNotAllocation() {
        if (!this.formNotAllocation.employeeRowGuid) {
            this.$message.error("Chọn nhân viên");
            return false;
        }
        if (!this.formNotAllocation.paymentType) {
            this.$message.error("Chọn hình thức chi");
            return false;
        }
        if (this.formNotAllocation.cost.length === 0) {
            this.$message.error("Nhập tổng chi");
            return false;
        }
        // if (!this.formNotAllocation.reason) {
        //     this.$message.error("Nhập lý do chi");
        //     return false;
        // }
        return true;
    }

    async onSaveNotAllocation() {
        if (!this.isValidFormNotAllocation()) return;
        await updateCostBillLading(this.formNotAllocation).then(
            (value) => {
                this.$message.success("Cập nhập chi phí thành công");
                this.formNotAllocation = cloneDeep(formNotAllocation);
            })
            .catch((e) => {
                this.$message.error(e?.response?.data?.message || 'Đã xảy ra lỗi');
            })
    }

    resetAllForm() {
        this.formNotAllocation = cloneDeep(formNotAllocation);
        this.form = cloneDeep(form);
        this.formTemp = cloneDeep(formTemp);
    }

}
